/**
 * Проверка контрольных разрядов ИНН (ТЗ FR-07).
 * Ошибка блокирует генерацию, поэтому проверка выполняется и на клиенте,
 * и на сервере — из одного и того же файла.
 */

const WEIGHTS_10 = [2, 4, 10, 3, 5, 9, 4, 6, 8];
const WEIGHTS_12_1 = [7, 2, 4, 10, 3, 5, 9, 4, 6, 8];
const WEIGHTS_12_2 = [3, 7, 2, 4, 10, 3, 5, 9, 4, 6, 8];

function checksum(digits: number[], weights: number[]): number {
  let sum = 0;
  for (let i = 0; i < weights.length; i++) sum += (weights[i] as number) * (digits[i] as number);
  return (sum % 11) % 10;
}

export type InnKind = 'person' | 'organization';

/** ИНН физического лица — 12 знаков, организации — 10. */
export function isValidInn(value: string, kind?: InnKind): boolean {
  const raw = (value ?? '').replace(/\s/g, '');
  if (!/^\d+$/.test(raw)) return false;
  if (raw.length !== 10 && raw.length !== 12) return false;
  if (kind === 'person' && raw.length !== 12) return false;
  if (kind === 'organization' && raw.length !== 10) return false;

  const d = raw.split('').map(Number);
  if (raw.length === 10) return checksum(d, WEIGHTS_10) === d[9];
  return checksum(d, WEIGHTS_12_1) === d[10] && checksum(d, WEIGHTS_12_2) === d[11];
}

export function innError(value: string, kind?: InnKind): string | null {
  const raw = (value ?? '').replace(/\s/g, '');
  if (!raw) return 'ИНН не указан';
  if (!/^\d+$/.test(raw)) return 'ИНН должен состоять только из цифр';
  if (kind === 'person' && raw.length !== 12) return 'ИНН физического лица содержит 12 цифр';
  if (kind === 'organization' && raw.length !== 10) return 'ИНН организации содержит 10 цифр';
  if (raw.length !== 10 && raw.length !== 12) return 'ИНН содержит 10 или 12 цифр';
  if (!isValidInn(raw, kind)) return 'Неверная контрольная сумма ИНН';
  return null;
}
